import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    if (error?.message?.includes('Error retrieving icon')) {
      console.warn('Icon load error suppressed:', error.message);
      return; // prevents the console from logging it
    }

    console.error(error);
  }
}
